import type { AxiosInstance } from 'axios';
import type { UserResponse, UserUpdateRequest } from '@/types';

export const getUser = async (api: AxiosInstance): Promise<UserResponse> => {
  const resp = await api.get(`/user`);
  return resp.data;
};

export const createUser = async (api: AxiosInstance): Promise<UserResponse> => {
  const resp = await api.post(`/user`);
  return resp.data;
};

export const updateUser = async (
  api: AxiosInstance,
  values: UserUpdateRequest,
): Promise<UserResponse> => {
  const resp = await api.put('/user', values);
  return resp.data;
};

export const deleteUser = async (api: AxiosInstance): Promise<void> => {
  const resp = await api.delete('/user');
  return resp.data;
};

